import { render, staticRenderFns } from "./wtSocialAsset.component.vue?vue&type=template&id=2fa2b04a&"
import script from "./wtSocialAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtSocialAsset.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports